import { CommonModule, DecimalPipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  VclAdditionalInfoModule,
  VclButtonModule,
  VclFormFieldModule,
  VclInputModule,
  VclInternalSearchModule,
  VclLinkModule,
  VclListModule,
  VclModalModule,
  VclTabsModule,
} from '@voxel/community';
import {
  VoxelCardModule,
  VoxelCheckboxModule,
  VoxelInputModule,
  VoxelLoadingModule,
  VoxelRadioButtonModule,
  VoxelTabsModule,
} from '@voxel/mobile';
import { LottieAnimationViewModule } from 'ng-lottie';

import { SharedComponentsModule } from './components/shared-components.module';
import { StringFormatDirective } from './directives/string.format.directive';
import { NumberPipe } from './pipe/number.pipe';
import { StringFormatPipe } from './pipe/string.format.pipe';
import { AbreCuentasService } from './services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from './services/communicator/channel-communicator/channel-communicator.service';
import { PortalPnImplService } from './services/communicator/channel-communicator/implementation/portalpn-impl.service';
import { SuperappImplService } from './services/communicator/channel-communicator/implementation/superapp-impl.service';
import { BioCatchService } from './services/external/biocatch/biocatch.service';
import { HeaderService } from './services/header/header.service';
import { HelpersService } from './services/helpers/helpers-onboarding.service';
import { StringHelperService } from './services/helpers/string-helper.service';
import { ValidationHelperService } from './services/helpers/validation-helper.service';
import { IdentificationService } from './services/identification/identification.service';
import { LoaderService } from './services/loader/loader.service';
import { LoadingService } from './services/loading/loading.service';
import { NavigationService } from './services/navigation/navigation-onboarding.service';
import { PostValidateService } from './services/post-validate/post-validate.service';
import { ProductLoaderService } from './services/product-loader/product-loader.service';
import { RequestService } from './services/request/request-onboarding.service';
import { DecimalDirective } from './directives/decimal.directive';
import { MoneyDirective } from './directives/money.directive';
import { PreValidateService } from './services/pre-validate/pre-validate.service';

/**
 * Configuración de los modulos base
 *
 * *Base modules config*
 */
const baseModules = [
  CommonModule,
  RouterModule,
  FormsModule,
];

/**
 * Configuración de los modulos de voxel community
 *
 * *voxel community modules config*
 */
const voxelModules = [
  VoxelCardModule,
  VoxelRadioButtonModule,
  VoxelLoadingModule,
  VoxelTabsModule,
  VoxelInputModule,
  VoxelCheckboxModule,
];

/**
 * Configuración de los modulos de community
 *
 * *Community modules config*
 */
const communityModules = [
  VclAdditionalInfoModule,
  VclButtonModule,
  VclFormFieldModule,
  VclInputModule,
  VclLinkModule,
  VclListModule,
  VclModalModule,
  VclTabsModule,
  VclInternalSearchModule,
];

@NgModule({
  declarations: [
    StringFormatDirective,
    DecimalDirective,
    MoneyDirective,
  ],
  imports: [
    ...baseModules,
    ...voxelModules,
    ...communityModules,
    SharedComponentsModule,
    LottieAnimationViewModule.forRoot(),
  ],
  exports: [
    ...baseModules,
    ...voxelModules,
    ...communityModules,
    SharedComponentsModule,
    StringFormatDirective,
    DecimalDirective,
    MoneyDirective,
  ],
  providers: [
    AbreCuentasService,
    ProductLoaderService,
    NavigationService,
    PostValidateService,
    PreValidateService,
    ValidationHelperService,
    ChannelCommunicatorService,
    SuperappImplService,
    PortalPnImplService,
    BioCatchService,
    LoadingService,
    HelpersService,
    RequestService,
    StringFormatPipe,
    NumberPipe,
    IdentificationService,
    HeaderService,
    StringHelperService,
    LoaderService,
    DecimalPipe,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})

export class SharedModule { }
export * from './services/communicator/platform-communicator/platform-communicator-onboarding.service';
export * from './services/communicator/platform-communicator/platform-communicator.interceptor';
export * from './services/communicator/endpoint/endpoint.service';
export * from './services/communicator/mock/mock.service';
